import { render, staticRenderFns } from "./ToogleFilterBox.vue?vue&type=template&id=56f677ce&scoped=true"
import script from "./ToogleFilterBox.vue?vue&type=script&lang=js"
export * from "./ToogleFilterBox.vue?vue&type=script&lang=js"
import style0 from "./ToogleFilterBox.vue?vue&type=style&index=0&id=56f677ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f677ce",
  null
  
)

export default component.exports